import React from 'react'
import { IoLogoPython } from 'react-icons/io5';
import { IconProps } from '../types';



export const PythonIcon = (props: IconProps) => {
    return (
        <IoLogoPython {...props} />
    )
}


PythonIcon.displayName = "PythonIcon"
